import { axiosGet } from "@/services/axiosService";
import { useQuery } from "@tanstack/react-query";

export default function useGetAllBotInOne(
  status: string = "",
  sortBy: string = "",
  page: any = "",
  limit: any = "",
  minimal: boolean = false,
) {
  return useQuery({
    queryKey: ["bots", "GetBotInOne", status, ...(minimal ? [page] : [])],
    queryFn: async () => {
      const response = await axiosGet(
        `/users/allBotInOne?status=${status}&sort=${sortBy}&page=${page}&per_page=${limit}&minimal=${minimal}`,
      );
      return response.data;
    },
    staleTime: 1000,
  });
}
